<infigo-detail-block>
	<app-skeleton [height]="'200px'" [loading]="loading">
		<n-tab
            [(activeItem)]="defaultActiveItem"
            [type]="'card'"
            class="only-one-tab"
            style="height: calc(100% - 0.33rem)"
        >
            <n-tab-item [header]="firstTabItem">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-member-port-table #memberPortTable [data]="portList" [portGroupMemberType]="portType" [loading]="updateLoading"></app-member-port-table>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
		</n-tab>
	</app-skeleton>
</infigo-detail-block>
